import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import activeChoiceReducer from "../reducers/active-choice";
import errorObserverReducer from "../reducers/error";
import loadingObserverReducer from "../reducers/loader";
import userReducer from "../reducers/user";
import positionsReducer from "../reducers/positions";
import settingsReducer from "../reducers/settings";
import notificationsMessagesReducer from "../reducers/notifications";

export function makeStore(preloadedState) {
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  return configureStore({
    reducer: {
      activeChoice: activeChoiceReducer,
      errorObserver: errorObserverReducer,
      loadingObserver: loadingObserverReducer,
      userInformationReducer: userReducer,
      vacanciesReducer: positionsReducer,
      settings: settingsReducer,
      notifications: notificationsMessagesReducer,
    },
    devTools: true,
    preloadedState,
    middleware: (getDefaultMiddleware) => (
      isDevelopment ? [...getDefaultMiddleware(), logger] : getDefaultMiddleware()
    ),
  })
}

const store = makeStore()

export default store
